<template>
  <div class="login">
    <div class="title">登录</div>
    <!-- <div class="coordinates-icon">
      <div class="coordinates topAct">
        <img src="static/images/logo.png" />
        <p>平安校园</p>
      </div>
      <div class="circle-1-1 circle-show-2"></div>
      <div class="circle-2-2 circle-show-1"></div>
      <div class="circle-3-3 circle-show"></div>
    </div> -->
    <div class="login-form">
      <form action="#">
        <div class="user-name common-div">
          <span class="eamil-icon common-icon">
            <i class="icon">&#xe601;</i>
          </span>
          <input type="text" name="username" v-model="username" placeholder="用户名" />       
          <img class="arrowDown" @click="showUser()" src="static/images/arrow-down.png" />   
        </div>
        
        <div class="user-pasw common-div">
          <span class="pasw-icon common-icon">
            <i class="icon">&#xe687;</i>
          </span>
          <input type="password" name="password" v-model="password" placeholder="密码" />
          <div class="userList" v-if="isShowUserList">
            <div v-for="(item, index) in userList" :key="index" @click="chooseUser(item)">{{item.username}}</div>
          </div> 
        </div>
        <div class="rememberPassword" @click="rememberPassword()">
          <img class="checkImg" v-if="!isRemember" src="static/images/gouxuan.png" />
          <img class="checkImg" v-if="isRemember" src="static/images/gouxuan1.png" />
          <span class="text" :class="{'color-0bd38a': isRemember}">记住密码</span>
        </div>
        <!-- <div class="type" style="margin-bottom: 20px;">
          <span style="margin-right: 20px;" :class="{'color-appStyle': userType == 2}" @click="swicthUserType(2)">学生</span>
          <span :class="{'color-appStyle': userType == 1}" @click="swicthUserType(1)">老师</span>
        </div> -->
        <div class="login-btn" @click="_login">用户名及密码登录</div>
        <div class="login-btn bg-appStyle" @click="authenticationLogin">统一认证登录</div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "../fetch/api";
import * as _ from "../util/tool";
import * as types from '../vuex/types';
import service from "@/fetch/service";
import * as crypto from "../util/crypto";

export default {
  data() {
    return {
      username: "",
      password: "",
      isRemember: true,
      isShowUserList: false,
      userType: 1
    };
  },
  created() {
    //记住密码
    let remberUserName = JSON.parse(localStorage.getItem('remberUserName'));
    console.log(remberUserName);
    if (remberUserName && remberUserName.length > 0) {
      this.userList = remberUserName;
      this.username = remberUserName[0].username;
      this.password = remberUserName[0].password
    }

    // sessionStorage.setItem("token", 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwYXNzd29yZCI6IjhjZTQ2Y2RjOWE0MjZmNWRjNWY1YTA1MTgzN2JiNzViYzBiMjM2OWQ1NDc1Nzc4MjA1MTI1NjBlYzM0YzY2Y2EiLCJ1bmFtZSI6IjE3NjIzNjA2MDY1IiwidCI6IjE1NzY1OTIxMjY5NzUiLCJuYW1lIjoi572X5aSp6ZuqIiwiaWQiOiIyNDU5NTU2MTAxOTIwIiwidXNlclR5cGUiOiIxIn0.NhOM_uKrtp6K5HeQ6HBYk6KIUpUnnIkGzcDrJ4fPcqs');
    //判断页面是否带tickets
    const urlParams = this.getRequest();
    console.log(urlParams);
    if (urlParams) {
      this.$store.dispatch("setLoadingState", true);
      service
      .serviceValidate({
        'serviceUrl': types.ServiceUrl,
        'ticket': urlParams
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        if (res.success) {
          //如果token存在 直接进入页面
          if (res.result.token) {
            sessionStorage.setItem("token", res.result.token);
            this.$router.push("indexMenuJointQuery");
          }else { //不存在就跳入绑定页面
            this.$router.push({name: "bindingPageJointQuery", query: {ssoBindAccount: res.result.ssoAccount}});
          }
        }
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        // _.alert(error.data.msg);
        console.log(error);
      });
    }
  },
  methods: {
    ...mapActions({}),
    //统一认证登录
    authenticationLogin() {
      console.log("统一认证登录");
      window.location.href = types.AuthenticationURL
    },
    getRequest() { 
      var url = location.search; //获取url中"?"符后的字串     
      if (url.indexOf("?") != -1) {   
          let index = url.indexOf("=");
          let str = url.substring(index+1);   
          return str;
      }     
    }, 
    swicthUserType(type) {
      this.userType = type;
      console.log(this.userType);
    },
    chooseUser(item) {
      this.username = item.username;
      this.password = item.password;
      this.isShowUserList = false;
    },
    showUser() {
      let remberUserName = JSON.parse(localStorage.getItem('remberUserName'))
      if (remberUserName && remberUserName.length > 0) {
        this.isShowUserList = this.isShowUserList ? false : true;
      }
    },
    rememberPassword() {
      this.isRemember = this.isRemember ? false : true;
    },
    // 用户登录
    _login() {
      if (!this.username || !this.password) {
        _.alert("请填写完整");
        return;
      }
      //进行sha256加密
      let sha256Password = crypto.sha256(this.password); 
      let data = {
        username: this.username,
        password: sha256Password,
        userType: this.userType //教师端1 学生2
      };
      this.$store.dispatch("setLoadingState", true);
      
      api
        .doLogin(data)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.$store.dispatch("setLoadingState", false);
            sessionStorage.setItem("token", res.result.token);
            if (this.isRemember) {
              let remberUserName = JSON.parse(localStorage.getItem('remberUserName'));
              if (remberUserName) {
                //判断是否有一致的用户名 先删除 再更新
                remberUserName.forEach((element, i) => {
                  if (element.username == this.username) {
                    remberUserName.splice(i, 1);
                  }
                });
                remberUserName.unshift({
                  username: this.username,
                  password: this.password
                })
              }else {
                remberUserName = [
                  {
                    username: this.username,
                    password: this.password
                  }
                ];
              }
              localStorage.setItem('remberUserName', JSON.stringify(remberUserName));
            }
            // this.$router.replace("/");
            this.$router.push("indexMenuJointQuery");
          }
        })
        .catch(error => {
          this.$store.dispatch("setLoadingState", false);
          _.alert(error.data.msg);
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";

.login {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #ececec;
  padding-bottom: px2rem(260px);
  .title {
    width: 100%;
    height: auto;
    overflow: hidden;
    font-size: px2rem(40px);
    text-align: center;
    height: px2rem(300px);
    line-height: px2rem(300px);
    color: #333;
  }
  .coordinates-icon {
    width: px2rem(400px);
    height: px2rem(250px);
    margin: px2rem(50px) auto;
    position: relative;
    .coordinates {
      width: px2rem(150px);
      overflow: hidden;
      position: absolute;
      z-index: 8;
      left: 32%;
      text-align: center;
      img {
        width: 100%;
        height: auto;
      }
      p {
        font-size: px2rem(30px);
        margin-top: px2rem(20px);
        color: #333;
      }
    }
    .circle-1-1 {
      width: 100%;
      height: px2rem(150px);
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 100%;
      background-color: #3a3d4a;
      position: absolute;
      bottom: 0;
      z-index: 1;
      opacity: 0;
    }
    .circle-2-2 {
      width: px2rem(230px);
      height: px2rem(80px);
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.4);
      border-radius: 100%;
      background-color: #4e515c;
      left: 75%;
      margin-left: px2rem(-217px);
      bottom: px2rem(35px);
      position: absolute;
      z-index: 2;
      opacity: 0;
    }
    .circle-3-3 {
      width: px2rem(130px);
      height: px2rem(50px);
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 100%;
      background-color: #71747d;
      z-index: 3;
      left: 35%;
      margin-left: px2rem(-8px);
      bottom: px2rem(50px);
      position: absolute;
      opacity: 0;
    }
  }
  .login-form {
    width: px2rem(600px);
    height: auto;
    margin: 0 auto;
    .common-div {
      width: 100%;
      height: px2rem(80px);
      // overflow: hidden;
      border-radius: 4px;
      margin-bottom: px2rem(50px);
      -moz-box-shadow:5px 5px 10px #d2d2d2; 
      -webkit-box-shadow:5px 5px 10px #d2d2d2; 
      box-shadow:5px 5px 10px #d2d2d2;
      > .common-icon {
        float: left;
        width: px2rem(40px);
        height: px2rem(40px);
        line-height: px2rem(40px);
        overflow: hidden;
        margin: px2rem(20px);
        text-align: center;
        img {
          width: 100%;
          height: auto;
        }
      }
      > input {
        float: left;
        line-height: px2rem(80px);
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 16px;
        color: #333;
      }
    }
    .user-name,
    .user-pasw {
      background-color: #fff;
      position: relative;
      .arrowDown {
        position: absolute;
        right: px2rem(20px);
        top: 50%;
        width: px2rem(30px);
        height: px2rem(30px);
        transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        /* Internet Explorer */
        -moz-transform: translateY(-50%);
        /* Firefox */
        -webkit-transform: translateY(-50%);
        /* Safari 和 Chrome */
        -o-transform: translateY(-50%);
        /* Opera */
      }
    }
    .userList {
        position: absolute;
        top: px2rem(-20px);
        left: 0;
        width: 100%;
        min-height: px2rem(230px);
        max-height: px2rem(500px);
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 99;
        background: rgba(255, 255, 255, 1);
        border-radius: px2rem(20px);
        >div {
          width: 100%;
          padding: px2rem(30px) px2rem(20px);
          border-bottom: 1px solid #ececec;
        }
      }
    .login-btn {
      background-color: #0bd38a;
      color: #fff;
      font-size: px2rem(28px);
      text-align: center;
      height: px2rem(100px);
      line-height: px2rem(100px);
      margin-bottom: px2rem(50px);
      border-radius: 4px;
    }
  }
  .rememberPassword {
    display: flex;
    align-items: center;
    margin-top: px2rem(30px);
    margin-bottom: px2rem(30px);
    .checkImg {
      width: px2rem(40px);
      height: px2rem(40px);
      margin-right: px2rem(30px);
    }
    .text {
      font-size: px2rem(18px);
    }
    .color-0bd38a {
      color: #0bd38a;
    }
  }
}

.topAct {
  animation: topAct 3s ease-in-out infinite;
  -webkit-animation: topAct 3s ease-in-out infinite;
  -moz-animation: topAct 3s ease-in-out infinite;
  -o-animation: topAct 3s ease-in-out infinite;
  -ms-animation: topAct 3s ease-in-out infinite;
}
@keyframes topAct {
  0% {
    top: px2rem(-100px);
  }
  50% {
    top: px2rem(-30px);
  }
  100% {
    top: px2rem(-100px);
  }
}
@-webkit-keyframes topAct {
  0% {
    top: px2rem(-100px);
  }
  50% {
    top: px2rem(-30px);
  }
  100% {
    top: px2rem(-100px);
  }
}
@-moz-keyframes topAct {
  0% {
    top: px2rem(-100px);
  }
  50% {
    top: px2rem(-30px);
  }
  100% {
    top: px2rem(-100px);
  }
}

.circle-show {
  animation: circleShow 3s ease-in-out infinite 1s;
  -webkit-animation: circleShow 3s ease-in-out infinite 1s;
  -moz-animation: circleShow 3s ease-in-out infinite 1s;
  -ms-animation: circleShow 3s ease-in-out infinite 1s;
  -o-animation: circleShow 3s ease-in-out infinite 1s;
}
@keyframes circleShow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes circleShow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-moz-keyframes circleShow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.circle-show-1 {
  animation: circleShow1 3s ease-in-out infinite 1.2s;
  -webkit-animation: circleShow1 3s ease-in-out infinite 1.2s;
  -moz-animation: circleShow1 3s ease-in-out infinite 1.2s;
  -ms-animation: circleShow1 3s ease-in-out infinite 1.2s;
  -o-animation: circleShow1 3s ease-in-out infinite 1.2s;
}
@keyframes circleShow1 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes circleShow1 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-moz-keyframes circleShow1 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.circle-show-2 {
  animation: circleShow2 3s ease-in-out infinite 1.4s;
  -webkit-animation: circleShow2 3s ease-in-out infinite 1.4s;
  -moz-animation: circleShow2 3s ease-in-out infinite 1.4s;
  -ms-animation: circleShow2 3s ease-in-out infinite 1.4s;
  -o-animation: circleShow2 3s ease-in-out infinite 1.4s;
}
@keyframes circleShow2 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes circleShow2 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-moz-keyframes circleShow2 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// LoginJointQuery.vue?4239896a